import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import { PermitAuthorityAutocomplete, PermitAuthority } from "../components/PermitAuthorityAutocomplete";
import { usePermitApplicationContext } from "../PermitApplicationContext";

export const SelectAuthorityStep: React.FC = () => {
  const { state, setAuthority } = usePermitApplicationContext();

  // Build selected authority from context state if authorityId exists
  const selectedAuthority: PermitAuthority | null =
    state.authority.authorityId && state.authority.authorityName
      ? { id: state.authority.authorityId, name: state.authority.authorityName }
      : null;

  const handleAuthorityChange = (authority: PermitAuthority | null) => {
    setAuthority(authority?.id ?? null, authority?.name ?? null);
  };

  return (
    <Box>
      <Typography variant="h5" component="h2" gutterBottom>
        Select Permitting Authority
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Choose the city or jurisdiction where you need a permit
      </Typography>

      <PermitAuthorityAutocomplete value={selectedAuthority} onChange={handleAuthorityChange} />

      <Paper variant="outlined" sx={{ mt: 3, p: 2, bgcolor: "grey.50" }}>
        <Typography variant="body2" color="text.secondary">
          <strong>Note:</strong> The selected authority will review and approve your permit application. Processing
          times may vary by jurisdiction.
        </Typography>
      </Paper>
    </Box>
  );
};

export default SelectAuthorityStep;
